import React from 'react'

export const DocumentListView = () => {
  return (
    <div>DocumentListView</div>
  )
}
